<template>
  <div style="overflow: hidden">
    <div class="title">基本信息</div>
    <div class="content">
      <div class="cell" id="company">
        <span>公司</span>
        <input type="text" placeholder="请输入公司名称" v-model="company" />
      </div>
      <div class="cell" id="name">
        <span>联系人</span>
        <input type="text" placeholder="请输入联系人姓名" v-model="name" />
      </div>
      <div class="cell" id="phone">
        <span>手机号</span>
        <input
          type="text"
          placeholder="请输入联系人手机号"
          maxlength="11"
          v-model="phone"
        />
      </div>
      <div class="cell" id="email">
        <span>邮箱</span>
        <input type="text" placeholder="请输入联系人邮箱" v-model="Email" />
      </div>
      <div class="cell" id="address">
        <span>地址</span>
        <input type="text" placeholder="请输入地址" v-model="address" />
      </div>
    </div>

    <div class="title" style="padding-top: 0" id="exhibitionarea">
      <div class="careful">注：CMEF直销展区、展团只能选择其一</div>
      CMEF直销展区
    </div>
    <div class="exhibitionarea">
      <div
        class="exhibition1"
        v-for="(item, index) in exhibition1List"
        :key="index + '1'"
        @click="changeEx(index)"
        :class="{ is_active: index == actIndex }"
      >
        <span class="span1">{{ item }}</span>
      </div>
      <div
        class="exhibition1"
        style="width: 100%"
        v-for="(item2, index2) in exhibition1List2"
        :key="index2 + '2'"
        @click="changeEx2(index2)"
        :class="{ is_active: index2 == actIndex2 }"
      >
        <span class="span1">{{ item2 }}</span>
      </div>

      <div style="margin-bottom: 0.2rem; width: 100%">
        <span style="font-size: 0.26rem; color: #353535; margin-left: 0.28rem"
          >展团</span
        >
      </div>

      <div
        class="exhibition1"
        v-for="(item3, index3) in exhibition1List3"
        :key="index3 + '3'"
        @click="changeEx3(index3)"
        :class="{ is_active: index3 == actIndex3 }"
      >
        <span class="span1">{{ item3 }}</span>
      </div>
    </div>

    <div class="title">展位预定</div>
    <div class="reserve">
      <div>
        <span style="font-size: 0.26rem; color: #353535">展位类型</span>
      </div>
      <div
        style="
          width: 100%;
          height: 1px;
          background-color: #e5e5e5;
          margin-top: 0.36rem;
        "
      ></div>
      <div style="padding: 0.36rem 0">
        <Checkbox v-model="single" label="" @on-change="check"></Checkbox>
        <span class="reserve_span1">光地</span>
        <span class="reserve_span2">（2332元/平米，18平米起订）</span>
        <!--                <div class="selectInput">-->
        <!--                    <i class="iconfont icon-jian1 icon" style="margin-left: 0.4rem" @click="g_jian" :class="{icon_dis:guangdi<19}"></i>-->
        <!--                    <span style="margin-left: 0.2rem;display: inline-block;width: 0.26rem;text-align: center">-->
        <!--                    {{guangdi}}-->
        <!--                </span>-->
        <!--                    <i class="iconfont icon-jiahao icon" style="margin-left: 0.2rem" @click="g_jia"></i>-->
        <!--                </div>-->
      </div>
      <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
    </div>

    <div class="reserve">
      <div style="padding: 0.36rem 0">
        <Checkbox v-model="single2" label="" @on-change="check2"></Checkbox>
        <span class="reserve_span1">标摊</span>
        <span class="reserve_span2">（15900元/9平米，9平米起订）</span>
        <!--                <div class="selectInput">-->
        <!--                    <i class="iconfont icon-jian1 icon" style="margin-left: 0.4rem" @click="g_jian2" :class="{icon_dis:biaotan<10}"></i>-->
        <!--                    <span style="margin-left: 0.2rem;display: inline-block;width: 0.26rem;text-align: center">-->
        <!--                    {{biaotan}}-->
        <!--                </span>-->
        <!--                    <i class="iconfont icon-jiahao icon" style="margin-left: 0.2rem" @click="g_jia2"></i>-->
        <!--                </div>-->
      </div>
      <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
    </div>
    <div class="reserve">
      <div style="padding: 0.36rem 0">
        <Checkbox v-model="single3" label="" @on-change="check3"></Checkbox>
        <span class="reserve_span1">养老展集市活动展位</span>
        <span class="reserve_span2">（8000元/6平米）</span>
      </div>
      <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
    </div>

    <!--icmd-->
    <div class="title">ICMD（医疗器械设计制造展区）</div>
    <div class="exhibitionarea">
      <div
        class="exhibition1"
        v-for="(item, index) in icmdExhibitionList"
        :key="index + '1'"
        @click="changeExicmd(index)"
        :class="{ is_active: index == actIndex4 }"
      >
        <span class="span1">{{ item }}</span>
      </div>
      <Input
        v-model="other"
        style="width: 5.4rem; margin: 0 0.1rem; margin-left: 0.3rem"
        type="text"
        v-if="inputShow"
        id="other"
      />
    </div>

    <div class="title">展位预定</div>

    <div class="reserve" id="reserve">
      <div style="padding: 0.36rem 0">
        <Checkbox v-model="single4" label="" @on-change="check4"></Checkbox>
        <span class="reserve_span1">ICMD光地</span>
        <span class="reserve_span2">（14840元/9平米，18平米起订）</span>
        <!--                <div class="selectInput">-->
        <!--                    <i class="iconfont icon-jian1 icon" style="margin-left: 0.4rem" @click="g_jian1" :class="{icon_dis:ICMDguangdi<19}"></i>-->
        <!--                    <span style="margin-left: 0.2rem;display: inline-block;width: 0.26rem;text-align: center">-->
        <!--                    {{ICMDguangdi}}-->
        <!--                </span>-->
        <!--                    <i class="iconfont icon-jiahao icon" style="margin-left: 0.2rem" @click="g_jia1"></i>-->
        <!--                </div>-->
      </div>
      <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
    </div>
    <div class="reserve">
      <div style="padding: 0.36rem 0">
        <Checkbox v-model="single5" label="" @on-change="check5"></Checkbox>
        <span class="reserve_span1">标摊</span>
        <span class="reserve_span2">（15900元/9平米，9平米起订）</span>
        <!--                <div class="selectInput">-->
        <!--                    <i class="iconfont icon-jian1 icon" style="margin-left: 0.4rem" @click="g_jian2" :class="{icon_dis:biaotan<10}"></i>-->
        <!--                    <span style="margin-left: 0.2rem;display: inline-block;width: 0.26rem;text-align: center">-->
        <!--                    {{biaotan}}-->
        <!--                </span>-->
        <!--                    <i class="iconfont icon-jiahao icon" style="margin-left: 0.2rem" @click="g_jia2"></i>-->
        <!--                </div>-->
      </div>
      <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
    </div>

    <!--展位面积-->
    <div class="area">
      <span class="area-title">展位面积</span>
      <div style="margin-top: 0.36rem">
        <span style="font-size: 0.24rem">面宽</span>
        <Input
          v-model="Width"
          style="width: 1.4rem; margin: 0 0.1rem"
          @on-change="exwidth"
          maxlength="4"
          type="number"
        />
        <span style="margin-right: 0.5rem">米</span>
        <span style="margin-right: 0.5rem">X</span>
        <span style="font-size: 0.24rem">进深</span>
        <Input
          v-model="Height"
          style="width: 1.4rem; margin: 0 0.1rem"
          @on-change="exheight"
          maxlength="4"
          type="number"
        />
        <span style="font-size: 0.24rem">米</span>
      </div>
      <div style="margin-top: 0.3rem; padding-bottom: 0.5rem">
        <span style="font-size: 0.24rem">面积</span>
        <div
          style="
            display: inline-block;
            width: 1.4rem;
            height: 0.64rem;
            background-color: #f2f2f2;
            border-radius: 0.1rem;
            border: solid 1px #cccccc;
            line-height: 0.64rem;
            padding-left: 4px;
            margin: 0 0.1rem;
          "
        >
          {{ exarea }}
        </div>
        <span>米</span>
      </div>
      <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
      <div style="padding: 0.5rem 0; font-size: 0.22rem; color: #666">
        <div>注：</div>

        <ul
          style="margin-left: 0.3rem; margin-top: 0.26rem; line-height: 0.4rem"
        >
          <li>会刊费：371元/每家企业/每届；</li>
          <li>
            网络推广费：4000元/家公司/年度（含6%增值税）用于线上企业店铺、产品展示及展会现场产品查询服务功能；
          </li>
          <li>以上价格均含6%增值税。</li>
        </ul>
      </div>
    </div>
    <div class="submitbtn">
      <div class="btn" @click="submit">
        <span>确定并提交申请</span>
      </div>
    </div>
  </div>
</template>

<script>
// (function(){
//     function w() {
//         var r = document.documentElement;
//         var a = r.getBoundingClientRect().width;//获取当前设备的宽度
//         if (a > 750 ){//720不固定，根据设计稿的宽度定
//             a = 750;
//         }
//         let rem = a / 7.5;
//         r.style.fontSize = rem + "px"
//     }
//     w();
//     window.addEventListener("resize", function() {//监听横竖屏切换
//         w()
//     }, false);
// })();

import { mapActions } from "vuex";

export default {
  name: "index",
  data() {
    return {
      actIndex: -1,
      actIndex2: -1,
      actIndex3: -1,
      actIndex4: -1,
      company: "",
      name: "",
      phone: "",
      Email: "",
      address: "",
      single: false,
      single2: false,
      single3: false,
      single4: false,
      single5: false,
      guangdi: 18,
      ICMDguangdi: 18,
      biaotan: 9,
      DePjNameGroupName: "", //选中的展区
      AgentName: "", //选中的展团
      Area: 0, //展位预定面积
      DePjName: "",
      UnitPrice: "",
      Unit: "",
      Width: 1, //面宽
      Height: 1, //进深
      exarea: 1, //面积
      icmdExhibitionList: [
        "材料区",
        "设计及研发区",
        "零部件、组件及模块区",
        "软件及数据处理区",
        "制造设备及OEM技术区",
        "包装及打印区",
        "洁净及消毒区",
        "相关服务区",
        "电机区",
        "电源区",
        "光学元器件区",
        "传动控制区",
        "流体控制区",
        "智能制造及芯片区",
        "其他（请注明）",
      ],
      exhibition1List: [
        "医用影像",
        "医用电子",
        "医用光学",
        "医用耗材",
        "骨科",
        "消毒感控",
        "IVD体外诊断",
        "手术室急救",
        "模拟医学",
        "医疗服务",
        "国际区",
      ],
      exhibition1List2: [
        "医院设备、医院建设及后勤管理",
        "国际智慧健康展",
        "国际康复及个人健康博览会",
        "国际养老福祉及护理用品博览会",
        "中国应急、安防及救援技术装备博览会",
      ],
      exhibition1List3: [
        "安徽展团",
        "北京展团",
        "福建展团",
        "广东展团",
        "广西展团",
        "广州展团",
        "国药联合",
        "海南展团",
        "河北展团",
        "河南展团",
        "黑龙江展团",
        "湖北展团",
        "湖南展团",
        "江苏展团",
        "江西展团",
        "救护车展团",
        "辽宁展团",
        "宁波展团",
        "山东展团",
        "山西展团",
        "陕西展团",
        "上海展团",
        "深圳展团",
        "四川展团",
        "台湾展团",
        "天津展团",
        "武汉展团",
        "浙江展团",
        "重庆展团",
        "浙江医疗器械行业协会展团",
      ],
      inputShow: false,
      other: "",
    };
  },
  components: {},
  computed: {},
  created() {
    document.title = "tHIS ASEAN Stand Application";
  },
  methods: {
    ...mapActions({
      ApplyScene: "ApplyScene",
    }),
    // 展区小数组
    changeEx(i) {
      this.actIndex2 = -1;
      this.actIndex3 = -1;
      this.actIndex4 = -1;
      this.single4 = false;
      this.single5 = false;
      if (this.actIndex == i) {
        return;
      }
      this.actIndex = i;
      this.DePjNameGroupName = this.exhibition1List[i];
      this.AgentName = "";
    },
    changeExicmd(i) {
      this.actIndex2 = -1;
      this.actIndex3 = -1;
      this.actIndex = -1;
      this.single = false;
      this.single2 = false;
      this.single3 = false;
      if (this.actIndex4 == i) {
        return;
      }
      this.actIndex4 = i;
      this.DePjNameGroupName = this.icmdExhibitionList[i];
      this.AgentName = "";
      if (i == 14) {
        this.inputShow = true;
      } else {
        this.inputShow = false;
        this.other = "";
      }
    },
    //展区后四个
    changeEx2(i) {
      this.actIndex = -1;
      this.actIndex3 = -1;
      this.actIndex4 = -1;
      this.single4 = false;
      this.single5 = false;
      if (this.actIndex2 == i) {
        return;
      }
      this.actIndex2 = i;
      this.DePjNameGroupName = this.exhibition1List2[i];
      this.AgentName = "";
    },
    //展团
    changeEx3(i) {
      this.actIndex = -1;
      this.actIndex2 = -1;
      this.actIndex4 = -1;
      this.single4 = false;
      this.single5 = false;
      if (this.actIndex3 == i) {
        return;
      }
      this.actIndex3 = i;
      this.AgentName = this.exhibition1List3[i];
      this.DePjNameGroupName = "";
    },
    //光地
    // g_jian(){
    //     if (this.guangdi>18){
    //         this.guangdi=this.guangdi-1
    //     }
    // },
    //ICMD光地
    // g_jian1(){
    //     if (this.ICMDguangdi>18){
    //         this.ICMDguangdi=this.ICMDguangdi-1
    //     }
    // },
    //标摊
    // g_jian2(){
    //     if (this.biaotan>9){
    //         this.biaotan=this.biaotan-1
    //     }
    // },
    // g_jia(){
    //     this.guangdi=this.guangdi+1
    // },
    // g_jia1(){
    //     this.ICMDguangdi=this.ICMDguangdi+1
    // },
    // g_jia2(){
    //     this.biaotan=this.biaotan+1
    // },
    exwidth() {
      this.exarea = this.Width * this.Height;
    },
    exheight() {
      this.exarea = this.Width * this.Height;
    },
    check(e) {
      this.single = e;
      this.single2 = false;
      this.single3 = false;
      this.single4 = false;
      this.single5 = false;
      this.actIndex4 = -1;
    },

    check2(e) {
      this.single2 = e;

      this.single = false;
      this.single3 = false;
      this.single4 = false;
      this.single5 = false;
      this.actIndex4 = -1;
    },
    check3(e) {
      this.single3 = e;

      this.single2 = false;
      this.single = false;
      this.single4 = false;
      this.single5 = false;
      this.actIndex4 = -1;
    },
    check4(e) {
      this.single4 = e;

      this.single2 = false;
      this.single3 = false;
      this.single5 = false;
      this.single = false;
      this.actIndex = -1;
      this.actIndex2 = -1;
      this.actIndex3 = -1;
    },
    check5(e) {
      this.single5 = e;

      this.single4 = false;
      this.single = false;
      this.single2 = false;
      this.single3 = false;
      this.actIndex = -1;
      this.actIndex2 = -1;
      this.actIndex3 = -1;
    },
    //根据错误定位
    goFail(ElepropName) {
      Element.prototype.documentOffsetTop = function () {
        return (
          this.offsetTop +
          (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
        );
      };
      console.log(ElepropName, "ElepropName");
      let top =
        document.getElementById(ElepropName).documentOffsetTop() -
        window.innerHeight / 2;
      window.scrollTo(0, top);
      return;
    },
    async submit() {
      if (!this.company) {
        this.$Message.info("请输入公司名称");
        this.goFail("company");
        return;
      }
      if (!this.name) {
        this.$Message.info("请输入联系人姓名");
        this.goFail("name");
        return;
      }
      if (!this.phone) {
        this.$Message.info("请输入联系人手机号");
        this.goFail("phone");
        return;
      }
      if (!this.Email) {
        this.$Message.info("请输入邮箱");
        this.goFail("email");
        return;
      }
      if (!this.address) {
        this.$Message.info("请输入地址");
        this.goFail("address");
        return;
      }
      if (
        !this.DePjNameGroupName &&
        !this.AgentName &&
        this.inputShow == false
      ) {
        this.$Message.info("请选择一个展团或者展区");
        this.goFail("exhibitionarea");
        return;
      }
      if (!this.other && this.inputShow == true) {
        this.$Message.info("请填写一个展团或者展区");
        this.goFail("other");
        return;
      }
      if (
        !this.single &&
        !this.single4 &&
        !this.single2 &&
        !this.single3 &&
        !this.single5
      ) {
        this.$Message.info("请选择一个预定类型");
        this.goFail("reserve");
        return;
      }
      if (this.inputShow) {
        this.DePjNameGroupName = this.other;
      }
      if (this.single) {
        this.Area = this.exarea;
        this.DePjName = "光地";
        this.Unit = "平米";
        this.UnitPrice = "2332";
      }

      if (this.single2 || this.single5) {
        this.Area = this.exarea;
        this.DePjName = "标摊";
        this.Unit = "平米";
        this.UnitPrice = "15900";
      }
      if (this.single3) {
        this.Area = this.exarea;
        this.DePjName = "养老展集市活动展位";
        this.Unit = "平米";
        this.UnitPrice = "8000";
      }
      if (this.single4) {
        this.Area = this.exarea;
        this.DePjName = "ICMD光地";
        this.Unit = "平米";
        this.UnitPrice = "14840";
      }
      if (this.inputShow && this.other == "") {
        this.$Message.info("请输入一个展区");
      }

      let opt = {
        CompanyName: this.company,
        LinkMan: this.name,
        LinkMob: this.phone,
        LinkEmail: this.Email,
        AgentName: this.AgentName,
        DePjNameGroupName: this.DePjNameGroupName,
        DePjName: this.DePjName,
        Area: this.Area,
        Unit: this.Unit,
        UnitPrice: this.UnitPrice,
        Width: this.Width,
        Height: this.Height,
        Address: this.address,
        MonetaryUnit: "元",
      };
      let res = await this.ApplyScene(opt);
      if (res.successed) {
        this.$router.push({ path: "/HomeMobile-success" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .ivu-checkbox {
  .ivu-checkbox-inner {
    width: 20px;
    height: 20px;
  }
}
::v-deep {
  .ivu-input {
    height: 0.5rem;
  }
}

.header {
  height: 1rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  span {
    font-size: 0.3rem;
  }
}
.title {
  font-size: 0.3rem;
  color: #353535;
  background-color: #f2f2f2;
  padding: 0.36rem 0 0.25rem 0.3rem;
}
.content {
  padding: 0 0.3rem;
  .cell {
    padding: 0.24rem 0;
    border-bottom: 1px solid #e5e5e5;
    span {
      color: #353535;
      font-size: 0.3rem;
      width: 1.8rem;
      display: inline-block;
    }
    input {
      border: 0px;
      outline: none;
      width: 3.5rem;
    }
  }
}
.exhibitionarea {
  padding: 0.3rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -0.28rem;
  .exhibition1 {
    width: 1.6rem;
    height: 0.68rem;
    background-color: #fff;
    border-radius: 0.1rem;
    border: solid 1px #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 0.2rem;
    margin-left: 0.28rem;
    .span1 {
      font-size: 0.24rem;
      color: #666;
    }
    &.is_active {
      border: solid 1px #ff5c00;
      .span1 {
        color: #ff5c00;
      }
    }
  }
}
.reserve {
  padding-left: 0.3rem;
  margin-top: 0.3rem;
  .reserve_span1 {
    font-size: 0.26rem;
    color: #353535;
  }
  .reserve_span2 {
    font-size: 0.26rem;
    color: #999;
  }
  .selectInput {
    display: flex;
    align-items: center;
    margin-top: 0.15rem;
    margin-bottom: 0.2rem;
  }
  .icon {
    transform: scale(2);
    color: #666;
  }
  .icon_dis {
    color: #e5e5e5;
  }
}
.submitbtn {
  background-color: #f2f2f2;
  padding: 0.95rem 0.3rem 0.4rem;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.88rem;
    background-color: #fe781d;
    border-radius: 0.05rem;

    span {
      font-size: 0.3rem;
      color: #fff;
    }
  }
}
.ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #2d8cf0;
  background-color: #2d8cf0;
}
.ivu-checkbox-checked:hover .ivu-checkbox-inner {
  border-color: #2d8cf0;
}
.area {
  margin-top: 0.5rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;
  &-title {
    color: #353535;
    font-size: 0.26rem;
  }
  input {
    font-size: 0.24rem;
    height: 64px;
  }
}
.cell {
  input {
    font-size: 0.24rem;
  }
}
.careful {
  color: red;
  font-size: 0.24rem;
  text-align: center;
}
</style>

